module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAflBMVEUAAAAnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrb///9FgsHy9vvu9Pnn7/fm7vbj7fZLh8PY5fK3zuesyOOnxOKXudySttpVjcZRi8VBgL/2+fzp8PjR4PC+0+mDrNWBqtRvns40d7ouc7gm/c3iAAAAD3RSTlMAyyTv+fSNT7euMzDljkjNXUqIAAAApElEQVQY03WRRxLDIAwAhcG4xop7SZxe///BjAJE5MBeEDugUQFDoUWpSqELYKIMHVnkZCWRkZWRiUIflXy/x/hPTElSvo/9nY4UIGdZX+bzg4IcNiy7Hc4DRRqEL/ftSKGA0spTvziJEpSVw4Jre0QDmA7eQ/daGyelzfvs66k5oEXYGm7TlSVqW+/WgUTOvTFpYA6BmZGO/ZdJcBe8N4nyt7cPlQYViaRar50AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_edit_active.png
// module id = 5rFW
// module chunks = 9